import { Injectable } from '@angular/core';
import { Offers } from '@app/core/models/offers.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PreviewOffer } from '../../core/models/offers.model';
import { HandleTokenService } from '../../core/services/handle-token.service';
import { OffersAPI } from '../../data/mo-api/offers.api';
import { OffersFacade } from '@app/facades/offers.facade';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  constructor(
    private _offersAPI: OffersAPI,
    private _handleTokenService: HandleTokenService,
    private _offersFacade: OffersFacade
  ) {}

  public setOffersLoopById(offers: Offers[], amount: string): Array<Observable<PreviewOffer>> {
    let getOffersById: Array<Observable<PreviewOffer>> = [];
    const transactionToken: string = this._handleTokenService.getTransactionToken();
    offers.map((offer) => {
      const offerId: string = offer.id;
      const numberOfInstallments: number = offer.repayment_frequency.minimum_installments;
      this._offersFacade.setNumberOfInstallments(numberOfInstallments);
      getOffersById = [
        ...getOffersById,
        this._addOfferIdToPreviewOffer(offerId, amount, numberOfInstallments, transactionToken),
      ];
    });

    return getOffersById;
  }

  public setPreviewOfferById(previewOffers: PreviewOffer[], id: string): PreviewOffer | undefined {
    const indexOfferById: number = previewOffers?.findIndex(
      (previewOffer) => previewOffer.id === id
    );
    return !!previewOffers ? previewOffers[indexOfferById] : undefined;
  }

  private _addOfferIdToPreviewOffer(
    id: string,
    amount: string,
    numberOfInstallments: number,
    transactionToken: string
  ): Observable<PreviewOffer> {
    return this._offersAPI.getOfferPreview(id, amount, numberOfInstallments, transactionToken).pipe(
      map((offer) => {
        return { ...offer, id };
      })
    );
  }

  public setTotalCostWithTaxes(totalCost: string, totalTaxes: string): string {
    const totalCostWithTaxes: number = Number(totalCost) + Number(totalTaxes);
    return totalCostWithTaxes.toFixed(2);
  }

  public setTotalCostWithTaxesInstallment(
    totalCost: string,
    totalTaxes: string,
    installments: number
  ): string {
    const totalCostWithTaxes: number = Number(totalCost) + Number(totalTaxes);
    const totalCostWithTaxesInstallment: number = totalCostWithTaxes / installments;
    return totalCostWithTaxesInstallment.toString();
  }
}
